import { PartialLocationObject } from '../../server/types/bellaRequest';
import ShopApi from './shopApiAdapter';
import { Config } from 'Common/appshell_types';

export const createApiService = (
    shopApiBaseUrl: string,
    config: Config,
    country: string,
    userAgent: string,
    location: PartialLocationObject
    // eslint-disable-next-line max-params
) => {
    const shopApi = new ShopApi(shopApiBaseUrl, config, country, userAgent, location);

    return {
        shopApi,
    };
};

export type ApiService = ReturnType<typeof createApiService>;

export default {
    createApiService,
};
